import { Component, OnInit, ViewChild } from '@angular/core';
import { VinPartsSearchComponent } from 'src/app/pages/official-website/ecat/vin-parts-search/vin-parts-search.component';
import { ProductSearchComponent } from 'src/app/pages/official-website/ecat/product-search/product-search.component';

@Component({
  selector: 'parts',
  templateUrl: './parts.component.html',
  styleUrls: ['./parts.component.less'],
})
export class PartsComponent implements OnInit {
  @ViewChild(VinPartsSearchComponent) vinPartsSearch!: VinPartsSearchComponent;
  @ViewChild(ProductSearchComponent) ProductSearch!: ProductSearchComponent;
  isVinSearchVisible = true;
  isVinPartsSearchVisible = false;
  isProductVinPartsSearchVisible = false;
  selectedTabIndex = 0;
  showDetail = false;
  selectedItem: any;
  carModalVisible = true;
  productVisible = false;
  constructor(
  ) { }
  ngOnInit(): void {
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
    if (index === 1) {
      this.carModalVisible = false;
      this.productVisible = true;
      this.isProductVinPartsSearchVisible = true;
    } else {
      this.carModalVisible = true;
      this.productVisible = false;
      this.isVinSearchVisible = true;
      this.isVinPartsSearchVisible = false;
      this.isProductVinPartsSearchVisible = false;
    }
  }

  receiveData(data: any) {
    this.isVinSearchVisible = false;
    this.isVinPartsSearchVisible = true;
  }

  receivePartsData(data: any) {
    this.isVinSearchVisible = true;
    this.isVinPartsSearchVisible = false;
  }
  onSearchByPartNo(partNo: any) {
    this.vinPartsSearch.searchByPartNo(partNo)
  }
  onViewDetail(item: any) {
    this.selectedItem = item;
    this.showDetail = true;
  }
  clearPartNoToFilter() {
    this.ProductSearch.clearSearchContent();
  }

  onBack() {
    this.showDetail = false;
  }
}
